module.exports = {
  "country": "UK",
  "artist": "Scott Fitzgerald",
  "song": "Go",
  "year": "1988",
  "place": "2",
  "spotify": "3Wf08J5GOEeydkW2ZzOd7V"
};